import React from 'react';
import { connect } from 'react-redux';
import { IDataStorage } from '../../core';
import { InputNumber } from '../prime';
import { IControlProps, MapProps } from './';
import styles from './inputnumber.module.scss';

interface IProps extends IControlProps<number | undefined> {
  storage?: IDataStorage;
  children?: React.ReactNode;

  /** minimo permitido */
  min?: number;
  /** máximo permitido */
  max?: number;

  /** Id del input */
  inputId?: string;
  /** class para el TextBox */
  inputClassName?: string;
  /** estilo para el TextBox */
  inputStyle?: React.CSSProperties;
}

interface IState extends IControlProps<number | undefined> {
  storage?: IDataStorage;

  min?: number;
  max?: number;

  inputId?: string;
  inputClassName?: string;
  inputStyle?: React.CSSProperties;

  /** Indica el mensaje de error si es que existe */
  validError?: string;
}

class Index extends React.Component<IProps, IState> {
  state: IState = {};
  componentDidMount = () => {
    Index.getDerivedStateFromProps(this.props, this.state);
    if (this.props?.form && this.props?.name) this.props.form.add(this, this.props.name, () => this.change(this.state.value));
  }
  static getDerivedStateFromProps = (p: IProps, s?: IState) : IState => {
    let res : IState = { };
    if (p?.storage !== s?.storage) res.storage = p.storage;
    if (p?.min !== s?.min) res.min = p.min;
    if (p?.max !== s?.max) res.max = p.max;
    if (p?.inputId !== s?.inputId) res.inputId = p.inputId;
    if (p?.inputClassName !== s?.inputClassName) res.inputClassName = p.inputClassName;
    if (p?.inputStyle !== s?.inputStyle) res.inputStyle = p.inputStyle;
    return MapProps(res, p, s);
  }

  render() {
    const { validError } = this.state;
    
    return (
      <div className={`form-group ${this.state.className ?? ''}`} style={this.state.style}>
        {this.state.title && <label className={(validError && styles.errortitle) ?? ''}>{this.state.title}</label>}
        <div className={`${styles.addons} p-inputgroup`}>
          {this.state.icon &&
            <span className={`p-inputgroup-addon`}>
              <i className={this.state.icon} />
            </span>
          }
          {this.state.required && 
            <span className={`p-inputgroup-addon ${(validError && styles.erroraddon) ?? ''}`}>
              <i className="pi pi-exclamation-circle" />
            </span>
          }
          <InputNumber
            inputId={this.state.inputId}
            value={this.state.value}
            placeholder={this.state.placeholder}
            readOnly={this.state.disabled}
            disabled={this.state.disabled}
            min={this.state.min}
            max={this.state.max}
            tooltip={validError}
            mode="decimal"
            locale="en-US"
            maxFractionDigits={2}
            format={false}
            tooltipOptions={{ position: 'bottom' }}
            onChange={e => !this.state.disabled && this.change(e.value)}
            onBlur={e => !this.state.disabled && this.change(!!e.target.value ? parseFloat(e.target.value) : undefined)}
            className={`w-100 p-inputtext ${styles.ctrl} ${styles.inputnumber} ${this.state.inputClassName ?? ''} ${validError && 'p-error'}`}
            style={this.state.inputStyle}
          />
          {this.props.children}
        </div>
        {validError && <span className={styles.errordesc}>{validError}</span>}
      </div>
    );
  }
  
  change = (value?: number) : string | undefined => {
    const { onChange, validate, isValid } = this.props;

    let error = this.validate(value);
    if (validate) error = validate(value);
    if (isValid) isValid(!error, error);
    
    this.setState({ validError: error });

    if (onChange) onChange(value, error);

    return error;
  }

  private validate = (value?: number) : string | undefined => {
    const { required } = this.state;

    if (required && value === undefined) return 'campo requerido';

    return undefined;
  }
}

export default connect((s:any) => ({ storage:s.main }))(Index);
